import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  drawer: false,
};

const drawerSlice = createSlice({
  name: "drawerSlice",
  initialState,
  reducers: {
    setDrawer: (state, action) => {
      state.drawer = true;
      return state;
    },
    resetDrawer: (state,action) => {
      state.drawer = false;
      return state;
    },
  },
});

export const { setDrawer,resetDrawer } = drawerSlice.actions;
export default drawerSlice;
